import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/iconfont/iconfont.css";
import global from './Global.js';
import {Get_Member_System, Refresh_Token} from "@/api/index";
import {Notify} from "vant";

Vue.config.productionTip = false;
Vue.prototype.global = global;

window.isLoadingMemberSystem = false;
Vue.prototype.global.setMemberSystem = async function (memberSystemId) {
    if (!window.isLoadingMemberSystem) {
        window.isLoadingMemberSystem = true;

        let memberSystem = sessionStorage.getItem("MemberSystem");
        if (!global.isNull(memberSystem)) {
            memberSystem = JSON.parse(memberSystem);
        }

        if (!global.isNull(memberSystem) && !global.isNull(memberSystemId) && memberSystem.memberSystemId == memberSystemId) {
            window.isLoadingMemberSystem = false;
            return;
        }

        //以用户优先，只要有登陆，经销商信息以用户的为主
        let user = global.getUserInfo();
        if (!global.isNull(user) && !global.isNull(user.memberSystemCode)) {
            //本地的经销商信息和要请求的信息一致，就不再请求
            if (!global.isNull(memberSystem) && memberSystem.code == user.memberSystemCode) {
                window.isLoadingMemberSystem = false;
                return;
            }
            memberSystemId = user.memberSystemId;
        }
        if (global.isNull(memberSystemId) || memberSystemId == 'undefined') {
            memberSystemId = "1";
        }

        await Get_Member_System({memberSystemId}).then(async memberSystem => {
            if (!global.isNull(memberSystem)) {
                if (memberSystem.extendInfo) {
                    try {
                        memberSystem.extendInfo = JSON.parse(memberSystem.extendInfo);
                    } catch (e) {
                        console.error('memberSystem.extendInfo解析异常', e)
                    }
                }
                sessionStorage.setItem("MemberSystem", JSON.stringify(memberSystem));
                window.isLoadingMemberSystem = false;
            } else {
                memberSystemId = 1;
                await Get_Member_System({memberSystemId}).then(memberSystem => {
                    if (!global.isNull(memberSystem)) {
                        if (memberSystem.extendInfo) {
                            try {
                                memberSystem.extendInfo = JSON.parse(memberSystem.extendInfo);
                            } catch (e) {
                                console.error('memberSystem.extendInfo解析异常', e)
                            }
                        }
                        sessionStorage.setItem("MemberSystem", JSON.stringify(memberSystem));
                        window.isLoadingMemberSystem = false;
                    }
                })
            }
        })
    }
}
Vue.prototype.global.getMemberSystem = async () => {
    let memberSystem = sessionStorage.getItem("MemberSystem");
    if (global.isNull(memberSystem)) {
        await global.setMemberSystem().then(() => {
            memberSystem = sessionStorage.getItem("MemberSystem");
        });
    }
    return JSON.parse(memberSystem);
}

Vue.prototype.global.refreshToken = async (refreshToken) => {
    /*将刷新token的标志置为true*/
    window.isRefreshing = true
    /*发起刷新token的请求*/
    await Refresh_Token({"refreshToken": refreshToken}).then(res => {
        window.isRefreshing = false;
        if (!global.isNull(res)) {
            res.memberSystemId = res.systemId
            localStorage.setItem("User", JSON.stringify(res));
            localStorage.setItem("AccessToken", res.accessToken);
            localStorage.setItem("RefreshToken", res.refreshToken);
        } else {
            localStorage.clear();
            router.push("/login");
        }
    }).catch(err => {
        router.push("/login");
    })
}

//使用钩子函数对路由进行权限跳转
router.beforeEach(async (to, from, next) => {
    // document.title = '汽修资料'+`${to.meta.title}`;
    let isVerify = true;
    let homePath = '';

    if (to.query.AccessToken && to.query.RefreshToken) {
        localStorage.setItem("AccessToken", to.query.AccessToken);
        localStorage.setItem("RefreshToken", to.query.RefreshToken);
    }
    // var memberSystemAreaType = 0;
    if (to.matched.some(record => record.meta.isHome)) {
        let memberSystemId = 1;
        if (!global.isNull(to.query) && !global.isNull(to.query.memberSystemId)) {
            memberSystemId = to.query.memberSystemId;
            await global.setMemberSystem(memberSystemId);
        }
    }
    let memberSystem = await global.getMemberSystem()
    let pcPathPerfix = '/pc';
    if (!global.isMobile()) {
        if (memberSystem.type == 1) {
            homePath = '/choose/0';
        }
        if (homePath != '' && to.matched.some(record => record.meta.isHome)) {
            next({
                path: pcPathPerfix + homePath,
            })
            isVerify = false;
        } else if (to.path.indexOf('/login') > -1) {
            localStorage.clear();
            next({
                path: pcPathPerfix + homePath,
                query: {login: new Date().getTime()}
            })
            isVerify = false;
        } else if (to.path.indexOf(pcPathPerfix) < 0) {
            next({
                path: pcPathPerfix + to.fullPath,
                query: to.query
            })
            isVerify = false;
        } else if (to.query.login) {
            localStorage.clear();
            next();
            isVerify = false;
        }

    } else {
        if (memberSystem.type == 1) {
            homePath = '/repair/0';
        }
        if (to.path.indexOf(pcPathPerfix) >= 0) {
            next({
                path: to.fullPath.replace(pcPathPerfix, '')
            })
            isVerify = false;
        }
    }
    if (to.matched.some(record => record.meta.isBuy)) {
        // let memberSystem = sessionStorage.getItem("MemberSystem");
        // if (!global.isNull(memberSystem)) {
        //     memberSystem = JSON.parse(memberSystem);
        if (memberSystem.isCanPay == 0) {
            Notify({type: 'warning', message: '请联系客服'});
            isVerify = false;
            next(false);
        }
        // }
    }
    if (isVerify) {
        if (to.matched.some(record => record.meta.requiresAuth)) { // && (homePath == '' || (memberSystem.type == 1 && to.path.indexOf(homePath) < 0))
            let user = global.getUserInfo();
            if (global.isNull(user)) {
                sessionStorage.setItem("redirectUrl", to.fullPath);
                next({
                    path: '/login',
                    query: {redirect: to.fullPath}
                })
            } else {
                next()
            }
        } else {
            next() // 确保一定要调用 next()
        }
    }
});

Vue.directive('preventright', {
    bind: function (el, binding, vnode) {
        // if (process.env.NODE_ENV !== 'development') {
        el.oncontextmenu = function () {
            return false
        }
        // }
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
